export default __webpack_public_path__ + "static/media/big-green-arrow.49b90967.png";